'use client';
import { FC, PropsWithChildren, ReactNode } from 'react';
import { ModalTranslationRequestProvider } from './_context/ModalTranslationRequestContext';

interface ITrannslationRequestLayout {
  modal: ReactNode;
}

const TrannslationRequestLayout: FC<PropsWithChildren<ITrannslationRequestLayout>> = ({
  modal,
  children
}) => {
  return (
    <ModalTranslationRequestProvider>
      {modal}
      {children}
    </ModalTranslationRequestProvider>
  );
};

export default TrannslationRequestLayout;
